import { useQuery } from '@tanstack/react-query';
import { fetchMarketTypeGroups } from './api';

export const marketsQueryKeys = {
  marketTypeGroups: ['markets', 'marketTypeGroups'] as const,
};

export function useMarketTypeGroupsQuery() {
  return useQuery({
    queryKey: marketsQueryKeys.marketTypeGroups,
    queryFn: fetchMarketTypeGroups,
    staleTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

